<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol>
        <MetaSection>
          <!-- <div class="text-right">
            <ArgonButton isRouteLink :to="{ name: 'User Create' }">Buat Baru</ArgonButton>
          </div> -->
        </MetaSection>
      </GridCol>
      <GridCol>
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="d-flex flex-row align-items-center justify-content-start" style="gap: 16px;">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData()" type="text" class="form-control"
                      placeholder="Cari NIP/nama pegawai..." style="border-right: 1px solid #d2d6da!important;" />
                  </InputGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.unitkerja_id"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Unit Kerja"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.jabatan_id"
                      :list="jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Jabatan"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.group_id"
                      :list="groups"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Hak Akses"
                    />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <ListView>
            <template v-slot:thead>
              <tr>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">NIP</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Nama</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Unit Kerja</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Jabatan</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Hak Akses</th>
                <th scope="col" class="text-secondary opacity-7">Aksi</th>
              </tr>
            </template>
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="7" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item.employee?.nip ?? "" }}</td>
                <td class="font-weight-bold">
                  <router-link :to="{
                      name: 'User Single',
                      params: { id: item?.id ?? 0 },
                    }" data-original-title="Manajemen User">{{ item.employee?.name ?? "-" }}</router-link>
                </td>
                <td><div class="column-truncate">{{ item.employee?.unitkerja?.name ?? "" }}</div></td>
                <td><div class="column-truncate">{{ item.employee?.jabatan?.name ?? "" }}</div></td>
                <td>
                  {{ getHakAkses(item) }}
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'User Single', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Detail</router-link>
                    <router-link :to="{ name: 'Log Aktivitas User', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Log Aktivitas</router-link>
                    <router-link :to="{ name: 'Edit User', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Edit</router-link>
                    <button @click="logoutData(item.id, item.username)" class="text-secondary font-weight-bold text-xs btn btn-link"
                      role="link" data-toggle="tooltip" data-original-title="Logout user" :disabled="!item.is_active">Logout</button>
                    <button @click="deleteData(item.id)" class="text-secondary font-weight-bold text-xs btn btn-link"
                      role="link" data-toggle="tooltip" data-original-title="Delete user" :disabled="!item.is_active">Nonaktifkan</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
            <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
          </ListView>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import UsersApi from '@/repository/api/UsersApi';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
// import ArgonButton from '@/components/ArgonButton.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import MetaSection from '@/components/MetaSection.vue';
import ListView from '@/components/ListView.vue';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from '@/repository/api/JabatanApi';
import GroupsApi from "@/repository/api/GroupsApi";
import InputGroup from '@/components/InputGroup.vue';
import FormGroup from '@/components/FormGroup.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "tables",
  components: {
    CardComponent,
    ThreeDotsMenu,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    InputGroup,
    FormGroup,
    ArgonPagination,
    ModelListSelect,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      unitkerja: [],
      jabatan: [],
      groups: [],
      params: {
        limit: "",
        keyword: "",
        unitkerja_id: "",
        jabatan_id: "",
        group_id: "",
        page: 1,
      },
      metaData: {}
    };
  },
  async mounted() {
    await this.getData();
    await this.getUnitKerja();
    await this.getGroups();
  },
  watch: {
    'params.group_id': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getData();
        }
      },
      deep: false,
    },
    'params.unitkerja_id': {
      handler: async function () {
        this.params.page = 1;
        this.params.jabatan_id = "";
        await this.getJabatan();
        await this.getData();
      },
      deep: true,
    },
    'params.jabatan_id': {
      handler: async function () {
        this.params.page = 1;
        await this.getData();
      },
      deep: true,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getGroups() {
      this.$store.state.loading = true;
      await GroupsApi.getbyparam({status:1}).then((response) => {
        this.groups = response.data
      }).catch(() => {
        this.groups = [];
      });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({ unitkerja_id: this.params.unitkerja_id, page: 'all', status: '1' }).then((response) => {
        this.jabatan = response.data;
      }).catch(() => {
        this.jabatan = [];
      })
      this.$store.state.loading = false;
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({page: 'all', status: 'active'}).then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    getHakAkses(item) {
      let hakakses = [];

      if ((item.groups ?? []) != []) {
        (item.groups ?? []).forEach(group => {
          hakakses.push(group?.name);
        });
      }


      return hakakses[hakakses.length - 1]
    },
    async getData() {
      clearTimeout(this.timer)
      if (this.params.keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (this.params.keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500)
      }
    },
    getEmployePhoto(path) {
      return "http://localhost:9100" + path;
    },
    async getDataAll() {
      this.$store.state.loading = true;
      await UsersApi.getbyparam(this.params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = this.params.page - 1;
        }
        this.data = [];
        this.metaData = {}
      })
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menonaktifkan?",
        showCancelButton: true,
      }).then(async (response) => {
        if (response.isConfirmed) {
          this.$store.state.loading = true;
          await UsersApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
          this.$store.state.loading = false;
        }
      });
    },
    async logoutData(id, username) {
      this.$swal({
        icon: "warning",
        title: `Logout Akun ${username}?`,
        showCancelButton: true,
      }).then(async (response) => {
        if (response.isConfirmed) {
          this.$store.state.loading = true;
          await UsersApi.logoutUser(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
          this.$store.state.loading = false;
        }
      });
    }
  },
};
</script>
